import { useEffect, useRef, useState } from "react";

const Quotes = () => {
  const text =
    "My heart is yours to hold and cherish for the rest of our days.";
  const [displayed, setDisplayed] = useState("");
  const [typing, setTyping] = useState(true);
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !inView) {
          setInView(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [inView]);

  useEffect(() => {
    if (!inView) return;

    setDisplayed("");
    setTyping(true);
    let i = 0;
    const interval = setInterval(() => {
      setDisplayed((prev) => prev + text[i]);
      i++;
      if (i >= text.length) {
        clearInterval(interval);
        setTyping(false);
      }
    }, 30);
    return () => clearInterval(interval);
  }, [inView]);

  return (
    <div className="h-[20rem] md:h-[100vh] bg-[#876935] flex flex-col justify-center pb-[4rem] md:pb-0">
      <div
        ref={containerRef}
        className="h-[20rem] md:h-[35rem] flex justify-center items-center relative px-8 overflow-hidden"
        style={{
          backgroundImage: `url('/images/golden-quotes.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="flex flex-col justify-center items-center w-full lg:w-3/4">
          <h3 className="font-ntFab font-semibold lg:font-normal text-2xl lg:text-6xl text-center text-[#FFFFFF]">
            {displayed}
            {typing && <span className="animate-pulse">|</span>}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Quotes;
